/* The Catalogue — search + facet filtering + soft keyword router.
   Implements wesbite/project/Catalogue.html behavior. Pure client-side:
   reads card data attributes, filters in place, no network calls. */
(function () {
  function init() {
    var root = document.querySelector("[data-cat-root]");
    if (!root) return;

    var grid = root.querySelector("#cat-grid");
    var emptyEl = root.querySelector("#cat-empty");
    var shownEl = root.querySelector("#cat-shown");
    var totalEl = root.querySelector("#cat-total");
    var summaryEl = root.querySelector("#cat-active-summary");
    var searchEl = root.querySelector("#cat-search");
    var qEl = root.querySelector("#cat-q");
    var clearBtn = root.querySelector("#cat-clear");
    var suggestEl = root.querySelector("#cat-suggest");
    var chipsRow = root.querySelector("#cat-active-chips");
    var hintEl = root.querySelector("#cat-hint");
    var sortSel = root.querySelector("#cat-sort");
    var resetBtn = root.querySelector("#cat-reset");
    var formatPills = root.querySelectorAll('[data-facet="format"]');

    var allCards = Array.from(grid.querySelectorAll(".cat-card"));
    var originalOrder = allCards.slice();
    var TOTAL = allCards.length;

    // Build a normalized item list from card data attributes (used by search/suggest)
    var ITEMS = allCards.map(function (c) {
      var latRaw = c.getAttribute("data-lat");
      var lngRaw = c.getAttribute("data-lng");
      return {
        el: c,
        id: c.getAttribute("href"),
        medium: c.getAttribute("data-medium") || "",
        country: c.getAttribute("data-country") || "",
        countryCode: (c.querySelector(".cat-card-meta")?.textContent || "").split(" · ")[0] || "",
        city: c.getAttribute("data-city") || "",
        format: c.getAttribute("data-format") || "",
        title: c.getAttribute("data-name") || "",
        desc: c.getAttribute("data-desc") || "",
        price: Number(c.getAttribute("data-price") || 0),
        search: (c.getAttribute("data-search") || "").toLowerCase(),
        lat: latRaw != null && latRaw !== "" ? parseFloat(latRaw) : null,
        lng: lngRaw != null && lngRaw !== "" ? parseFloat(lngRaw) : null
      };
    });

    // Soft keyword router — used by suggest only, doesn't auto-apply
    var ROUTES = [
      { re: /\bradio\b/i, set: { format: "Radio Stations" } },
      { re: /\bbillboards?\b/i, set: { format: "Billboards" } },
      { re: /\b(mall|indoor)\b/i, set: { format: "Mall & Indoor Screens" } },
      { re: /\b(newspaper|press)\b/i, set: { medium: "press" } },
      { re: /\b(tv|broadcast)\b/i, set: { format: "TV (Broadcast)" } },
      { re: /\b(stream|vod)\b/i, set: { format: "Streaming & VoD" } },
      { re: /\b(cinema|movie)\b/i, set: { format: "Cinema" } },
      { re: /\b(dooh|digital screen)\b/i, set: { format: "Digital Screens (DOOH)" } },
      { re: /\b(street|bus stop)\b/i, set: { format: "Street Furniture" } },
      { re: /\b(transit|metro)\b/i, set: { format: "Transit" } },
      { re: /\baudio\b/i, set: { medium: "audio" } },
      { re: /\bvideo\b/i, set: { medium: "video" } },
      { re: /\booh\b/i, set: { medium: "ooh" } },
      { re: /\b(saudi|ksa|riyadh|jeddah|dammam|khobar)\b/i, set: { country: "Saudi Arabia" } },
      { re: /\b(uae|emirates|dubai|abu dhabi|abudhabi|sharjah|ajman)\b/i, set: { country: "UAE" } },
      { re: /\b(qatar|doha)\b/i, set: { country: "Qatar" } },
      { re: /\b(jordan|amman)\b/i, set: { country: "Jordan" } },
      { re: /\b(netherlands|rotterdam|amsterdam)\b/i, set: { country: "Netherlands" } },
      { re: /\b(uk|britain|london|manchester)\b/i, set: { country: "UK" } },
      { re: /\b(usa|america|new york|los angeles|chicago)\b/i, set: { country: "USA" } },
      { re: /\b(egypt|cairo|alexandria)\b/i, set: { country: "Egypt" } },
      { re: /\b(morocco|casablanca|rabat)\b/i, set: { country: "Morocco" } },
      { re: /\b(singapore)\b/i, set: { country: "Singapore" } },
      { re: /\b(oman|muscat)\b/i, set: { country: "Oman" } },
      { re: /\b(bahrain|manama)\b/i, set: { country: "Bahrain" } },
      { re: /\b(kuwait)\b/i, set: { country: "Kuwait" } },
      { re: /\b(lebanon|beirut)\b/i, set: { country: "Lebanon" } },
      { re: /\b(italy|milan|rome)\b/i, set: { country: "Italy" } },
      { re: /\b(algeria|algiers)\b/i, set: { country: "Algeria" } },
      { re: /\b(tunisia|tunis)\b/i, set: { country: "Tunisia" } }
    ];

    var state = { q: "", medium: "all", country: "all", format: "all", sort: "featured", nearLat: null, nearLng: null, nearLabel: "" };
    var activeIdx = -1;

    var nearBar = root.querySelector("#cat-near-bar");
    var nearLabelEl = root.querySelector("#cat-near-label");
    var nearClearBtn = root.querySelector("#cat-near-clear");

    // ===== Geocoding =====
    var geocodeCache = new Map();
    var geocodeAbort = null;
    function geocode(query) {
      var key = query.toLowerCase().trim();
      if (geocodeCache.has(key)) return Promise.resolve(geocodeCache.get(key));
      if (geocodeAbort) geocodeAbort.abort();
      geocodeAbort = (typeof AbortController !== "undefined") ? new AbortController() : null;
      var url = "https://nominatim.openstreetmap.org/search?format=json&limit=1&addressdetails=1&q=" + encodeURIComponent(query);
      return fetch(url, geocodeAbort ? { signal: geocodeAbort.signal } : undefined)
        .then(function (r) { return r.ok ? r.json() : []; })
        .then(function (arr) {
          if (!arr || !arr.length) { geocodeCache.set(key, null); return null; }
          var hit = arr[0];
          var addr = hit.address || {};
          var primary = addr.road || addr.neighbourhood || addr.suburb || addr.city || addr.town || addr.village || addr.county || addr.state || (hit.display_name || "").split(",")[0];
          var country = addr.country || "";
          var res = { lat: parseFloat(hit.lat), lng: parseFloat(hit.lon), label: country ? (primary + ", " + country) : primary };
          geocodeCache.set(key, res);
          return res;
        })
        .catch(function () { return null; });
    }

    function detectLocationIntent(q) {
      var s = (q || "").trim();
      // Raw coords "25.2048, 55.2708"
      var m = s.match(/^(-?\d{1,3}(?:\.\d+)?)\s*,\s*(-?\d{1,3}(?:\.\d+)?)\s*$/);
      if (m) return { type: "coord", lat: parseFloat(m[1]), lng: parseFloat(m[2]), label: m[1] + ", " + m[2] };
      // "near X" / "around X" / "close to X"
      m = s.match(/^(?:near|around|close to|by)\s+(.+)$/i);
      if (m && m[1].trim().length >= 2) return { type: "near", query: m[1].trim() };
      return null;
    }

    function haversineKm(la1, lo1, la2, lo2) {
      if (la1 == null || lo1 == null || la2 == null || lo2 == null) return Infinity;
      var R = 6371, r = Math.PI / 180;
      var dLa = (la2 - la1) * r, dLo = (lo2 - lo1) * r;
      var a = Math.sin(dLa / 2) * Math.sin(dLa / 2)
        + Math.cos(la1 * r) * Math.cos(la2 * r) * Math.sin(dLo / 2) * Math.sin(dLo / 2);
      return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    function fmtDistance(km) {
      if (!isFinite(km)) return "";
      if (km < 1) return Math.round(km * 1000) + " m";
      if (km < 10) return km.toFixed(1) + " km";
      return Math.round(km) + " km";
    }

    function setNear(lat, lng, label) {
      state.nearLat = lat; state.nearLng = lng; state.nearLabel = label || "";
      if (lat != null && lng != null) {
        nearBar.hidden = false;
        nearLabelEl.textContent = state.nearLabel || (lat.toFixed(3) + ", " + lng.toFixed(3));
      } else {
        nearBar.hidden = true;
        nearLabelEl.textContent = "";
      }
    }

    nearClearBtn.addEventListener("click", function () {
      setNear(null, null, "");
      qEl.value = ""; state.q = "";
      updateSearchUI();
      render();
      qEl.focus();
    });

    // Geocode runner (debounced)
    var geocodeTimer = null;
    var geocodePending = "";
    function maybeGeocode() {
      var intent = detectLocationIntent(state.q);
      if (!intent) {
        if (state.nearLat != null || state.nearLng != null) setNear(null, null, "");
        return;
      }
      if (intent.type === "coord") {
        setNear(intent.lat, intent.lng, intent.label);
        render();
        return;
      }
      if (intent.type === "near") {
        if (geocodePending === intent.query && state.nearLat != null) return;
        geocodePending = intent.query;
        nearBar.hidden = false;
        nearLabelEl.textContent = "Searching…";
        clearTimeout(geocodeTimer);
        geocodeTimer = setTimeout(function () {
          geocode(intent.query).then(function (hit) {
            if (geocodePending !== intent.query) return; // user typed something newer
            if (hit) {
              setNear(hit.lat, hit.lng, hit.label || intent.query);
              render();
            } else {
              nearLabelEl.textContent = "No place found for “" + intent.query + "”";
              setTimeout(function () { if (geocodePending === intent.query) { nearBar.hidden = true; } }, 2400);
            }
          });
        }, 500);
      }
    }

    function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

    function escapeRegex(s) { return s.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"); }

    function highlight(text, query) {
      if (!query) return escapeHtml(text);
      var t = escapeHtml(text);
      var tokens = Array.from(new Set(query.toLowerCase().split(/\s+/).filter(function (x) { return x.length > 1; })));
      tokens.forEach(function (tok) {
        var re = new RegExp("(" + escapeRegex(tok) + ")", "ig");
        t = t.replace(re, "<mark>$1</mark>");
      });
      return t;
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
      });
    }

    function score(item, query) {
      if (!query) return 0;
      var hay = item.search;
      var tokens = query.toLowerCase().split(/\s+/).filter(Boolean);
      var s = 0;
      tokens.forEach(function (t) {
        if (item.title.toLowerCase().startsWith(t)) s += 6;
        if (item.title.toLowerCase().indexOf(t) !== -1) s += 3;
        if (hay.indexOf(t) !== -1) s += 1;
      });
      return s;
    }

    function matchFilters(item) {
      if (state.medium !== "all" && item.medium !== state.medium) return false;
      if (state.country !== "all" && item.country !== state.country) return false;
      if (state.format !== "all" && item.format !== state.format) return false;
      // Near mode: skip text-match (query is a location query, not a product query) and
      // require the item to have coordinates.
      if (state.nearLat != null && state.nearLng != null) {
        if (item.lat == null || item.lng == null) return false;
        return true;
      }
      if (state.q) {
        var query = state.q.trim().toLowerCase();
        var tokens = query.split(/\s+/).filter(Boolean);
        for (var i = 0; i < tokens.length; i++) {
          if (item.search.indexOf(tokens[i]) === -1) return false;
        }
      }
      return true;
    }

    function filtered() {
      var rs = ITEMS.filter(matchFilters);
      // Near mode wins all other sorts: distance ASC
      if (state.nearLat != null && state.nearLng != null) {
        rs.forEach(function (it) {
          it._dist = haversineKm(state.nearLat, state.nearLng, it.lat, it.lng);
        });
        rs.sort(function (a, b) { return (a._dist || Infinity) - (b._dist || Infinity); });
        return rs;
      }
      if (state.sort === "price-asc") rs.sort(function (a, b) { return (a.price || Infinity) - (b.price || Infinity); });
      else if (state.sort === "price-desc") rs.sort(function (a, b) { return (b.price || 0) - (a.price || 0); });
      else if (state.sort === "alpha") rs.sort(function (a, b) { return a.title.localeCompare(b.title); });
      if (state.q.trim()) {
        var Q = state.q.trim();
        rs.sort(function (a, b) { return score(b, Q) - score(a, Q); });
      }
      return rs;
    }

    function syncPills(facet) {
      root.querySelectorAll('[data-facet="' + facet + '"]').forEach(function (p) {
        p.setAttribute("aria-pressed", p.getAttribute("data-val") === state[facet] ? "true" : "false");
      });
    }

    function scopeFormatPills() {
      formatPills.forEach(function (p) {
        var v = p.getAttribute("data-val");
        var m = p.getAttribute("data-medium") || "all";
        if (v === "all" || state.medium === "all" || m === state.medium) {
          p.hidden = false;
        } else {
          p.hidden = true;
        }
      });
    }

    function applyHighlights(query) {
      ITEMS.forEach(function (it) {
        var h = it.el.querySelector(".cat-card-h");
        var d = it.el.querySelector(".cat-card-desc");
        if (h) h.innerHTML = highlight(it.title, query);
        if (d && it.desc) d.innerHTML = highlight(it.desc, query);
      });
    }

    function render() {
      var rs = filtered();
      var visibleSet = new Set(rs.map(function (x) { return x.el; }));

      // Toggle visibility (don't reorder unless sort active)
      ITEMS.forEach(function (it) {
        it.el.classList.toggle("is-hidden", !visibleSet.has(it.el));
      });

      // Reorder by current ranking
      rs.forEach(function (it) { grid.appendChild(it.el); });
      // Append hidden ones back at end to preserve original order in DOM (cheap)
      originalOrder.forEach(function (el) {
        if (!visibleSet.has(el)) grid.appendChild(el);
      });

      shownEl.textContent = rs.length;
      totalEl.textContent = TOTAL;
      emptyEl.classList.toggle("is-on", rs.length === 0);
      grid.style.display = rs.length === 0 ? "none" : "";

      // Distance pill on each card (clear when not in near mode)
      ITEMS.forEach(function (it) {
        var existing = it.el.querySelector(".cat-card-dist");
        if (state.nearLat != null && state.nearLng != null && visibleSet.has(it.el) && isFinite(it._dist)) {
          if (!existing) {
            existing = document.createElement("span");
            existing.className = "cat-card-dist";
            var meta = it.el.querySelector(".cat-card-meta");
            if (meta) meta.parentNode.insertBefore(existing, meta);
          }
          existing.textContent = fmtDistance(it._dist);
        } else if (existing) {
          existing.remove();
        }
      });

      // In near mode the search query isn't a product-text query, so don't highlight
      applyHighlights(state.nearLat != null ? "" : state.q.trim());
      renderChips();
      renderSummary();
    }

    function renderChips() {
      var chips = [];
      if (state.medium !== "all") chips.push({ k: "medium", v: state.medium, label: cap(state.medium) });
      if (state.country !== "all") chips.push({ k: "country", v: state.country, label: state.country });
      if (state.format !== "all") chips.push({ k: "format", v: state.format, label: state.format });
      if (state.q.trim()) chips.push({ k: "q", v: state.q, label: '"' + state.q.trim() + '"' });
      chipsRow.innerHTML = chips.map(function (c) {
        return '<button type="button" class="cat-chip" data-k="' + c.k + '">' + escapeHtml(c.label) + ' <span class="cat-chip-x" aria-hidden="true">×</span></button>';
      }).join("");
      chipsRow.querySelectorAll(".cat-chip").forEach(function (el) {
        el.addEventListener("click", function () {
          var k = el.getAttribute("data-k");
          if (k === "q") { qEl.value = ""; state.q = ""; updateSearchUI(); }
          else { state[k] = "all"; syncPills(k); if (k === "medium") scopeFormatPills(); }
          render();
        });
      });
    }

    function renderSummary() {
      var bits = [];
      if (state.medium !== "all") bits.push(cap(state.medium));
      if (state.country !== "all") bits.push(state.country);
      if (state.format !== "all") bits.push(state.format);
      summaryEl.textContent = bits.join(" · ");
    }

    function suggestions() {
      var query = state.q.trim();
      if (!query) return { direct: [], facets: [] };
      var direct = ITEMS
        .map(function (it) { return { it: it, s: score(it, query) }; })
        .filter(function (x) { return x.s > 0; })
        .sort(function (a, b) { return b.s - a.s; })
        .slice(0, 6)
        .map(function (x) { return x.it; });
      var facets = [];
      for (var i = 0; i < ROUTES.length; i++) {
        var r = ROUTES[i];
        if (r.re.test(query)) {
          var k = Object.keys(r.set)[0];
          var v = r.set[k];
          if (state[k] !== v) facets.push({ k: k, v: v, label: "Filter " + k + ": " + v });
        }
      }
      return { direct: direct, facets: facets };
    }

    function renderSuggest() {
      var s = suggestions();
      if (!s.direct.length && !s.facets.length) { suggestEl.classList.remove("has-results"); return; }
      suggestEl.classList.add("has-results");
      var Q = state.q.trim();
      var html = "";
      if (s.direct.length) {
        html += '<div class="cat-sugg-group"><div class="cat-sugg-group-h"><span>Placements</span><span>' + s.direct.length + '</span></div>';
        html += s.direct.map(function (it, i) {
          var price = it.price > 0 ? "From " + (window.Shopify && Shopify.currency ? Shopify.currency.active : "") + " " + Math.round(it.price / 100).toLocaleString() : "On enquiry";
          var sub = [it.country, it.city, it.format].filter(Boolean).join(" · ");
          return '<a class="cat-sugg-item" data-medium="' + it.medium + '" data-action="open" data-id="' + escapeHtml(it.id) + '" data-i="' + i + '" href="' + escapeHtml(it.id) + '">' +
            '<div class="cat-sugg-l"><div class="cat-sugg-ti"><span class="cat-dot"></span><strong>' + highlight(it.title, Q) + '</strong></div><div class="cat-sugg-sub">' + escapeHtml(sub) + '</div></div>' +
            '<div class="cat-sugg-r">' + escapeHtml(price) + '</div></a>';
        }).join("");
        html += "</div>";
      }
      if (s.facets.length) {
        html += '<div class="cat-sugg-group"><div class="cat-sugg-group-h"><span>Suggested filters</span></div>';
        html += s.facets.map(function (f, i) {
          return '<div class="cat-sugg-item" data-action="facet" data-k="' + f.k + '" data-v="' + escapeHtml(f.v) + '" data-i="' + (s.direct.length + i) + '">' +
            '<div class="cat-sugg-l"><div class="cat-sugg-ti"><strong>' + escapeHtml(f.label) + '</strong></div><div class="cat-sugg-sub">Apply as a filter</div></div>' +
            '<div class="cat-sugg-r">↵</div></div>';
        }).join("");
        html += "</div>";
      }
      html += '<div class="cat-sugg-tip"><span>↑↓ navigate · ↵ select · Esc close</span><span><kbd>⌘K</kbd> from anywhere</span></div>';
      suggestEl.innerHTML = html;
      activeIdx = -1;
      suggestEl.querySelectorAll(".cat-sugg-item").forEach(function (el) {
        el.addEventListener("mouseenter", function () { setActive(parseInt(el.getAttribute("data-i"), 10)); });
        el.addEventListener("click", function (ev) {
          if (el.getAttribute("data-action") === "facet") {
            ev.preventDefault();
            commit(el);
          }
        });
      });
    }

    function setActive(i) {
      activeIdx = i;
      suggestEl.querySelectorAll(".cat-sugg-item").forEach(function (el, idx) {
        el.classList.toggle("is-active", idx === i);
      });
    }

    function commit(el) {
      if (!el) return;
      var action = el.getAttribute("data-action");
      if (action === "facet") {
        var k = el.getAttribute("data-k");
        var v = el.getAttribute("data-v");
        state[k] = v;
        syncPills(k);
        if (k === "medium") scopeFormatPills();
        qEl.value = ""; state.q = "";
        updateSearchUI();
        render();
      } else if (action === "open") {
        var href = el.getAttribute("data-id");
        if (href) window.location.href = href;
      }
    }

    function updateSearchUI() {
      searchEl.classList.toggle("has-value", state.q.length > 0);
      renderSuggest();
    }

    qEl.addEventListener("input", function (e) { state.q = e.target.value; updateSearchUI(); maybeGeocode(); render(); });
    qEl.addEventListener("focus", function () { searchEl.classList.add("has-focus"); renderSuggest(); });
    qEl.addEventListener("blur", function () { setTimeout(function () { searchEl.classList.remove("has-focus"); }, 140); });
    clearBtn.addEventListener("click", function () { qEl.value = ""; state.q = ""; setNear(null, null, ""); updateSearchUI(); render(); qEl.focus(); });

    qEl.addEventListener("keydown", function (e) {
      var items = suggestEl.querySelectorAll(".cat-sugg-item");
      if (e.key === "ArrowDown") { e.preventDefault(); setActive(Math.min(activeIdx + 1, items.length - 1)); }
      else if (e.key === "ArrowUp") { e.preventDefault(); setActive(Math.max(activeIdx - 1, 0)); }
      else if (e.key === "Enter") {
        e.preventDefault();
        var target = items[activeIdx] || items[0];
        if (target) commit(target);
      }
      else if (e.key === "Escape") { qEl.value = ""; state.q = ""; setNear(null, null, ""); updateSearchUI(); render(); }
    });

    document.addEventListener("keydown", function (e) {
      if ((e.metaKey || e.ctrlKey) && e.key && e.key.toLowerCase() === "k") {
        e.preventDefault();
        qEl.focus(); qEl.select();
      }
    });

    root.querySelectorAll(".cat-pill").forEach(function (p) {
      p.addEventListener("click", function () {
        var f = p.getAttribute("data-facet");
        var v = p.getAttribute("data-val");
        state[f] = v;
        syncPills(f);
        if (f === "medium") {
          // If active format isn't valid for the new medium, reset format
          var fp = root.querySelector('[data-facet="format"][aria-pressed="true"]');
          if (fp && state.medium !== "all") {
            var fpMedium = fp.getAttribute("data-medium");
            if (fpMedium && fpMedium !== "all" && fpMedium !== state.medium) {
              state.format = "all";
              syncPills("format");
            }
          }
          scopeFormatPills();
        } else if (f === "format") {
          var fm = p.getAttribute("data-medium");
          if (state.format !== "all" && fm && fm !== "all" && fm !== "other") {
            state.medium = fm;
            syncPills("medium");
            scopeFormatPills();
          }
        }
        render();
      });
    });

    sortSel.addEventListener("change", function (e) { state.sort = e.target.value; render(); });

    resetBtn.addEventListener("click", function () {
      state.q = ""; state.medium = "all"; state.country = "all"; state.format = "all"; state.sort = "featured";
      setNear(null, null, "");
      qEl.value = "";
      ["medium", "country", "format"].forEach(syncPills);
      sortSel.value = "featured";
      scopeFormatPills();
      updateSearchUI(); render();
    });

    // Deep-link support
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get("medium")) state.medium = params.get("medium");
      if (params.get("country")) state.country = params.get("country");
      if (params.get("format")) state.format = params.get("format");
      if (params.get("q")) { state.q = params.get("q"); qEl.value = state.q; }
      ["medium", "country", "format"].forEach(syncPills);
      scopeFormatPills();
      updateSearchUI();
    } catch (e) { /* no-op */ }

    render();
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
